import React, { useEffect, useState } from 'react'
import { AppBar, Button, Container, Toolbar, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useParams, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { isEqual, cloneDeep } from 'lodash'
import LoadingOverlay from '../../../components/Misc/LoadingOverlay'
import BasicInfo from '../../../components/Cards/Facility/BasicInfo'
import Services from '../../../components/Cards/Facility/Services'
import LaunchState from '../../../components/Cards/Facility/LaunchState'
import ClientAppContent from '../../../components/Cards/Facility/ClientAppContent'
import Configurations from '../../../components/Cards/Facility/Configurations'

import { getApartmentList, updateFacility, reloadFacilities } from '../../../actions/facilities/facilities.actions'

const useStyles = makeStyles((theme) => ({
	root: {
		// flexGrow: 1,
		paddingTop: '24px',
		paddingLeft: '25px',
		paddingRight: '20px',
		paddingBottom: '75px'
	},
	appBar: {
		top: 'auto',
		bottom: 0,
		paddingRight: '0px !important'
	}
}))

const FacilityBasicInfo = () => {
	const classes = useStyles()
	const params = useParams()
	const dispatch = useDispatch()
	const history = useHistory()

	const selectedFacility = useSelector((state) => state.specific.facilities.selected)

	const loading = useSelector((state) => state.specific.facilities.loading)

	const [current, setCurrent] = useState(null)
	const [isSaveShown, setIsSaveShown] = useState(false)

	useEffect(() => {
		dispatch(reloadFacilities())
	}, [])

	useEffect(() => {
		if (params.facilityId && selectedFacility) {
			setCurrent(cloneDeep(selectedFacility))
			// dispatch(getApartmentList(selectedFacility.market_id))
		}
	}, [params.facilityId, selectedFacility])

	useEffect(() => {
		if (current && selectedFacility) {
			let facilityEqual = !isEqual(current, selectedFacility)

			setIsSaveShown(facilityEqual)
		}
	}, [current, selectedFacility])

	const saveSelectedFacility = () => {
		let updates = { ...current }
		dispatch(updateFacility(selectedFacility._id, updates))
	}

	const clearChanges = () => {
		setCurrent(cloneDeep(selectedFacility))
	}

	return (
		<div>
			{current ? (
				<Container className={classes.root} maxWidth="auto">
					<Typography variant="h5" style={{ fontWeight: 800, marginBottom: 16 }}>
						Basic Info
					</Typography>
					<BasicInfo selectedFacility={current} setCurrent={setCurrent} />
					<Services selectedFacility={current} setCurrent={setCurrent} />
					<LaunchState selectedFacility={current} setCurrent={setCurrent} />
					<ClientAppContent selectedFacility={current} setCurrent={setCurrent} />
					<Configurations selectedFacility={current} setCurrent={setCurrent} />

					{isSaveShown ? (
						<AppBar position="fixed" color="primary" className={classes.appBar}>
							<Toolbar>
								<Container maxWidth="md">
									<Button
										variant="contained"
										color="secondary"
										disabled={loading}
										style={{ marginRight: '8px' }}
										onClick={() => saveSelectedFacility()}>
										Save Changes
									</Button>
									<Button variant="outlined" color="secondary" onClick={clearChanges}>
										Cancel
									</Button>
								</Container>
							</Toolbar>
						</AppBar>
					) : null}
				</Container>
			) : null}
			{loading ? <LoadingOverlay /> : null}
		</div>
	)
}

export default FacilityBasicInfo
